import { render, staticRenderFns } from "./AgencyAgents.vue?vue&type=template&id=79156766"
import script from "./AgencyAgents.vue?vue&type=script&lang=js"
export * from "./AgencyAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports